import { render } from "./DesignWorksheetSTEM.vue?vue&type=template&id=0aee4b55&scoped=true"
import script from "./DesignWorksheetSTEM.vue?vue&type=script&lang=js"
export * from "./DesignWorksheetSTEM.vue?vue&type=script&lang=js"

import "./DesignWorksheetSTEM.vue?vue&type=style&index=0&id=0aee4b55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aee4b55"]])

export default __exports__